import { render, staticRenderFns } from "./expert-detail.vue?vue&type=template&id=636a3a72&scoped=true"
import script from "./expert-detail.vue?vue&type=script&lang=js"
export * from "./expert-detail.vue?vue&type=script&lang=js"
import style0 from "./expert-detail.vue?vue&type=style&index=0&id=636a3a72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a3a72",
  null
  
)

export default component.exports